<template>
  <div>
    <div class="header-fixed">
      <span style="float:left;margin-top:8px;margin-left:6px;">
        <img
          src="@/assets/logo.png"
          alt="Blubirch Logo"
        />
      </span>
      <span>
        <HeaderComponent :headerTitle="headerText" />
      </span>
    </div>

    <v-container class="ma-0 pa-0" fluid grid-list-lg>
      <v-layout class="ma-0 pa-0" row wrap>
        <v-flex class xs12 style="background-color:grey lighten-3">
          <v-row class="mt-2">
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget(item)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/wms_dashboard.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">Dashboard</div>
              </v-card>
            </v-col> -->

             <!--Ria Return Creation -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ReturnCreationRia', 19)" 
              v-if="(
                (!$isRelianceClient()) && 
                (currentUser.roles.includes('area_service_manager') || 
                currentUser.roles.includes('branch_service_manager') || 
                currentUser.roles.includes('central_admin') || 
                currentUser.roles.includes('regional_customer_service_manager') ||
                currentUser.roles.includes('service_head') ||
                currentUser.roles.includes('warehouse_manager')
                ))">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Return Creation
                </div>
              </v-card>
            </v-col>
            <!-- Reverse Approval -->
             <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('returning', 20)" v-if="!$isRelianceClient()" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/return_approval.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Return Approval
                </div>
              </v-card>
            </v-col>
             <!-- Reverse Logistics -->
            <v-col xs3 cols="3" sm="3"md="3" @click="navigateTarget('ReverseLogistics', 21)" v-if="!$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/reverse_logistics.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Reverse Logistics
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ftaDisposition', 2)" v-if="!$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/fta.svg" style="height: 108px;" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  FTA
                </div>
              </v-card>
            </v-col>
            <v-col xs3  cols="3" sm="3" md="3"  @click="navigateTarget(organization_name === 'Voltas' || $isRelianceClient() ? 'reverseDisposition' : 'rfDisposition', 1)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/disposition.png"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Disposition
                </div>
              </v-card>
            </v-col>


            <!-- <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('Disposition')"
              v-if="currentUser.roles.includes('forward_user')"
            >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/disposition.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Test
                </div>
              </v-card>
            </v-col> -->            
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('PRD', 3)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/upload.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  PRD
                </div>
              </v-card>
            </v-col>
            <!-- Inwarding Module -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('inward', 6)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/issue_resoluation.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  inward
                </div>
              </v-card>
            </v-col>
             <!-- Put Away module -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('PutAway', 5)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/pickup.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Putaway/Pick Up
                </div>
              </v-card>
            </v-col> 
              <!-- Transfer -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('Transfer', 22)" v-if="!$isRelianceClient()" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/module-menu-3.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Transfer
                </div>
              </v-card>
            </v-col>

             <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('PhysicalInspection', 12)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/physical_inspection.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Physical Inspection
                </div>
              </v-card>
            </v-col>
            
            <!-- Dashboard -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('dashboardNew', 0)" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/dashboard_icon.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Dashboard
                </div>
              </v-card>
            </v-col>
             <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('Report', 11)" v-if="!$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/reports.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Reports
                </div>
              </v-card>
            </v-col>
             <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('Settings', 13)"  v-if="currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin')">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/settings.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Settings
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3"  @click="navigateTarget('NewDispatch', 4)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/dispatch_new.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Dispatch
                </div>
              </v-card>
            </v-col>  
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('IssueResolution')" v-if="(organization_name != 'Voltas') && (!$isRelianceClient())">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/issue_resoluation.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Issue Resolution
                </div>
              </v-card>
            </v-col> -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('pending_Return_Request_Approval', 7)" v-if="organization_name !== 'Voltas' && !$isRelianceClient()" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/pending_return.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Pending Return Request Approval
                </div>
              </v-card>
            </v-col>   
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('PendingIssues', 8)" v-if="organization_name !== 'Voltas' && !$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/issues.svg"
                    width="108"
                    height="108"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Issues
                </div>
              </v-card>
            </v-col>
           
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('threePClaim', 9)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/3p_claim.svg"
                    width="108"
                    height="108"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  3p Claim
                </div>
              </v-card>
            </v-col>
            <!-- approval Request -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('approvalRequest', 10)"  v-if="organization_name !== 'Voltas'">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/pending_return.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Approval Request 
                </div>
              </v-card>
            </v-col>   

            <!-- <v-col
              xs3
              cols="3"
              sm="3"
              md="3"
              @click="navigateTarget('StnDocumentUploadList')"
              v-if="
                currentUser.roles.includes('central_admin') ||
                  currentUser.roles.includes('site_admin') ||
                  currentUser.product_access.includes('STN Upload') ||
                  currentUser.product_access.includes('All')
              "
            >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/upload.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  PRD Upload
                </div>
              </v-card>
            </v-col> -->
            <v-col xs3  cols="3" sm="3" md="3" @click="navigateTarget('WmsChart', 14)" v-if="organization_name !== 'Voltas' && organization_name != 'Reliance'">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/dashboard.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Chart
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ItemInfo', 15)">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/item_info.svg"
                    height="106px"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Item Information
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('DocumentNumber', 16)" v-if="organization_name !== 'Voltas' && !$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/archive-1.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Document Number
                </div>
              </v-card>
            </v-col>
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('FileUploadList', 17)" v-if="!$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/lot_file_upload.svg"
                    height="106px"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Lot File Upload
                </div>
              </v-card>
            </v-col> -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('InboundDocumentIndex', 18)" v-if="organization_name !== 'Voltas' && !$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img
                    class="mt-3"
                    src="@/assets/images/icons/inbound_documents_card.svg"
                  />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Documents List
                </div>
              </v-card>
            </v-col>
            <!-- Return Creation -->
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('RetunrCreation')"
              v-if="currentUser.roles.includes('central_admin') ||
              currentUser.roles.includes('site_admin') ||
              currentUser.product_access.includes('Inbound Documents') ||
              currentUser.product_access.includes('All') " >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Return Creation
                </div>
              </v-card>
            </v-col> -->
           <!-- Retur Approval -->
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ReturnApproval')"
              v-if="currentUser.roles.includes('central_admin') ||
              currentUser.roles.includes('site_admin') ||
              currentUser.product_access.includes('Inbound Documents') ||
              currentUser.product_access.includes('All') " >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Return Approval
                </div>
              </v-card>
            </v-col> --> 

            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ErrorListing', 25)" v-if="!$isRelianceClient()" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/error-listing.svg" style="width:108px;"/>
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Error Listing
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ApiConfiguration', 26)" v-if="!$isRelianceClient()" >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/apiconfig.svg" style="width:108px;"/>
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  API Configuration
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('generate', 27)"  v-if="$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/trackid.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Generate & Track Tag IDs
                </div>
              </v-card>
            </v-col>
             <!-- Reverse Pickup -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('ReversePickupNew')" v-if="organization_name !== 'Voltas' && !$isRelianceClient()">
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Reverse Pickup
                </div>
              </v-card>
            </v-col>
             <!-- Inward Tracking -->
            <!-- <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('inwardTracking')"
              v-if="currentUser.roles.includes('central_admin') ||
              currentUser.roles.includes('site_admin') ||
              currentUser.product_access.includes('Inbound Documents') ||
              currentUser.product_access.includes('All') " >
              <v-card class="pa-4 box_shadow_class mt-0">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/inward-tracking.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Inward Tracking
                </div>
              </v-card>
            </v-col> -->
            <!-- Grading -->
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateTarget('grading', 23)">
              <v-card class="pa-4 box_shadow_class mt-0" @click="updateActiveTabForGrading">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/grading.svg" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Grading
                </div>
              </v-card>
            </v-col>
            <v-col xs3 cols="3" sm="3" md="3" @click="navigateToLink('', 24)">
              <v-card class="pa-4 box_shadow_class mt-0" @click="updateActiveTabForGrading">
                <div align="center" justify="center">
                  <img class="mt-3" src="@/assets/images/icons/private_market.png" />
                </div>
                <div class="mt-3 text-color" align="center" justify="center">
                  Private Marketplace
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none;
  visibility: hidden;
}
.text-color {
  color: #0357d0;
}
.header-background {
  background-color: #0357d0;
}
.box_shadow_class {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 4px;
}

.header-fixed {  position: sticky; top: 0; z-index: 9999;}


</style>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { mapState } from "vuex";
import { defineComponent } from 'vue'; 
import {securedAxiosInstance, plainAxiosInstance, IS_QA_SERVER, private_market_place} from '@/backend/axios'

export default defineComponent({
  data() {
    return {
      active_tab: "Billing",
      headerText: "Warehouse Management System",
      organization_name :'',
    };
  },
  components: {
    HeaderComponent
  },
  computed: mapState(["currentUser", "signedIn"]),
  created(){
    this.organization_name = this.$store.state.organization_name
  },
  methods: {
    loadData(tab) {
      this.active_tab = tab;
    },
    updateActiveTabForGrading(){
      this.$store.commit('setActiveTab',{
        'active_tab' : ''
      })
    },
    navigateTarget(routerName, activeNumber) {
      this.$store.commit("setLotIds", {
            lotIds: activeNumber
          });
      this.$router.push({ name: routerName });
    },
    navigateToLink() {
      window.open(private_market_place, '_blank');
    },
  }
});
</script>
